import BaseButton from 'base-components/BaseButton/BaseButton';
import BaseValidatedInput from 'base-components/BaseValidatedInput/BaseValidatedInput';

import { useEffect, useRef } from 'react';
import { useMutation } from 'react-query';
import { useSearchParams } from 'react-router-dom';
import { Alert } from 'reactstrap';
import { requiredRule } from 'rules/validateRules';
import 'scss/Main.scss';
import Window from '../Window';
import { useAuth } from 'hooks/useAuth';

export type LoginForm = {
    username: string;
    password: string;
};

const Login = () => {
    const { login } = useAuth()

    const [searchParams] = useSearchParams();

    const userRef = useRef<HTMLInputElement>(null);

    const redirectUri = searchParams.get('redirectUri');

    const loginMutation = useMutation(
        async (data: LoginForm) => {
            login()
            return data
        },
        {
            onSuccess: (data) => {
                const target = redirectUri ?? '/';

                window.location.href = target;
            },
        }
    );

    const onSubmit = (data: LoginForm) => {
        loginMutation.mutate(data);
    };

    useEffect(() => {
        const current = userRef?.current as any;
        if (current && current instanceof HTMLInputElement) {
            current.focus();
        }
    }, []);

    const defaultForm = {
        username: '',
        password: '',
    }

    return (
        <Window<LoginForm>
            onSubmit={(data) => onSubmit(data)}
            label={'Вход'}
            defaultValues={defaultForm}>
            <BaseValidatedInput<LoginForm>
                data-testid="input-username"
                id="username"
                name="username"
                placeholder={'Login'}
                type="text"
                innerRef={userRef}
                disabled={loginMutation.isLoading}
                rules={{ required: requiredRule }}
                label={'Логин'}
            />
            <BaseValidatedInput<LoginForm>
                data-testid="input-password"
                id="password"
                name="password"
                placeholder={'Password'}
                type="password"
                disabled={loginMutation.isLoading}
                rules={{ required: requiredRule }}
                label={'Пароль'}
            />
            {loginMutation.isError && (
                <Alert color="danger" data-testid="alert-error">
                    {loginMutation.error as any}
                </Alert>
            )}
            <BaseButton
                type="submit"
                isPending={loginMutation.isLoading}
                color="primary"
                data-testid="login-button"
            >
                <span>
                    Войти
                </span>
            </BaseButton>
        </Window>
    );
};

export default Login;
